module.exports = __webpack_public_path__ + "img/3_1.a811c7c0.png";